import {
    Container,
    Form,
    FormGroup,
    Label
} from '../styles/AddScenarioPage.styles';
import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import { ToastState } from "@/components/auth/types/register.types.ts";
import { Toast } from "@/components/ui/Toast.tsx";
import { Button } from "@/components/ui/Button.tsx";
import { FlexJustifyBetweenAlignCenter } from "@/components/ui/FlexBox.ts";
import { styled } from "styled-components";
import * as yaml from 'js-yaml';
import { scenarioApi } from "@/api/scenarios.ts";
import {useNavigate, useParams} from "react-router-dom";

const StyledFileName = styled.div`
    margin-left: 14px;
    max-width: 255px;
    overflow: hidden;
    text-overflow: ellipsis;
`

const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
`;

const StyledCheckbox = styled.input`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    appearance: none;
    border: 1px solid #ddd;
    outline: none;
    cursor: pointer;
    position: relative;

    &:checked {
        background-color: rgb(77, 105, 156);
        border-color: rgb(77, 105, 156);
    }

    &:checked::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 12px;
    }
`;

interface YamlMetadata {
    name: string;
    description: string;
}

interface YamlData {
    metadata: YamlMetadata;
}

export const ImportFromFileTab = () => {
    const [toast, setToast] = useState<ToastState>({
        show: false,
        message: '',
        type: 'success'
    });
    const { register, handleSubmit, setValue } = useForm();
    const [fileName, setFileName] = useState('');
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { id } = useParams();
    const navigate = useNavigate();

    const onSubmit = async (data: any) => {
        const { file, is_default } = data;
        const fileContent = await file.text();

        try {
            const yamlData: YamlData = yaml.load(fileContent) as YamlData;
            if (yamlData.metadata.name && id) {
                const payload = {
                    name: yamlData.metadata.name,
                    assistant_id: Number(id),
                    description: yamlData.metadata.description || '',
                    is_default: !!is_default,
                    yaml_content: fileContent,
                };

                scenarioApi.createFromYaml(payload).then(() => {
                    setToast({
                        show: true,
                        message: 'Сценарий успешно создан',
                        type: 'success'
                    })
                    navigate(`/dashboard/assistants/${id}/scenarios`);
                }).catch(() => {
                    setToast({
                        show: true,
                        message: 'Не удалось создать сценарий',
                        type: 'error'
                    })
                })
            } else {
                setToast({
                    show: true,
                    message: 'В файле отсутствуют необходимые параметры',
                    type: 'error'
                });
            }
        } catch (e) {
            setToast({
                show: true,
                message: 'Ошибка при парсинге файла',
                type: 'error'
            });
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setFileName(file?.name || '');
        if (file) {
            setValue('file', file); // Добавляем файл в форму
        }
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Container>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(prev => ({ ...prev, show: false }))}
                />
            )}
            <Form onSubmit={handleSubmit(onSubmit)}>
                <FormGroup style={{ alignItems: 'center' }}>
                    <Label>Ассистент</Label>
                    <FlexJustifyBetweenAlignCenter>
                        <Button
                            variant="primary"
                            type="button"
                            style={{ padding: '3px 10px' }}
                            onClick={handleButtonClick}
                        >
                            Выбрать с диска
                        </Button>
                        {fileName && <StyledFileName>{fileName}</StyledFileName>}
                        <input
                            {...register('file')}
                            type="file"
                            ref={fileInputRef} // Привязываем ref к инпуту
                            style={{ display: 'none' }} // Скрываем инпут
                            onChange={handleFileChange} // Обрабатываем изменение файла
                        />
                    </FlexJustifyBetweenAlignCenter>
                </FormGroup>
                <FormGroup>
                    <Label></Label>
                    <CheckboxLabel>
                        <StyledCheckbox
                            type="checkbox"
                            {...register('is_default')}
                        />
                        По умолчанию
                    </CheckboxLabel>
                </FormGroup>
                <FormGroup>
                    <Label />
                    <Button variant="primary" type="submit">
                        Добавить
                    </Button>
                </FormGroup>
            </Form>
        </Container>
    );
};
